import { createFileRoute } from "@tanstack/react-router";
import { Error404Component } from "@/components/Error";

export const Route = createFileRoute("/_error/404")({
	component: Error404Component,
});
